import { numericExtent, stdDevSeries } from "../utils";
const STDDEV = {
    name: "StdDev",
    compute: (bars, period = 20) => stdDevSeries(bars.map((b) => b.close), period),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default STDDEV;
